import { render, staticRenderFns } from "./RegistrationHeader.vue?vue&type=template&id=3ee84ee0&scoped=true&"
import script from "./RegistrationHeader.vue?vue&type=script&lang=js&"
export * from "./RegistrationHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHeader.vue?vue&type=style&index=0&id=3ee84ee0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee84ee0",
  null
  
)

export default component.exports